import XanaduContract from '../contracts/XanaduContract.js';
import BPM from "./BPM.js";
import accounts from 'accounts/Accounts.js';
import ethereum from 'decentralized/ethereum.js';
import Annotator from './Annotator.js';
import EthereumTransaction from '../transactions/EthereumTransaction.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import {getRootFromLink} from 'decentralized/xanadu/getRootFromLink.js';
import {SEQUENCE_USED_SOUND} from './LinkTypes.js';
import {ipfsHashToBytes32} from 'utils/ipfsHash.js';
import RecursiveQuery from 'decentralized/EthereumQuery.js';
import {contracts} from '../transactions/contracts.js';
import Base from './Base.js';
import {XANADU} from '../transactions/contracts.js';
import Rater from './Rater.js';
import LinkFolder from 'repos/LinkFolder.js';
import PresetResamples from './PresetResamples.js';
import {
    NewAnnotationType,
    NewAnnotation,
    NewLinkType,
    NewLink,
    NewDataType
} from 'decentralized/EthereumEvents.js';

/**
 * Wrapper for Xanadu smart contract's methods
 * Create new data types, link types, annotation types
 * create links/annotations
 * Search through events 
 */

const MIN_BLOCK = 7636000;

class Xanadu extends PresetResamples(BPM(Rater(Annotator(Base)))) {
    constructor(web3) {
        super();
        this.web3 = web3;
        this.contract = new XanaduContract().getContract(web3);
        this.linkFolder = new LinkFolder(SEQUENCE_USED_SOUND);
        this.sequencesCache = undefined;
    }

    load() {
        return this.linkFolder.loadRoot(this);
    }

    async newDataType(dataType, description) {
        await new EthereumTransaction(
            XANADU,
            'newDataType',
            [this.web3.utils.fromAscii(dataType), description])
            .execute();
   }

    async newLinkType(linkType, description) {
        await new EthereumTransaction(
            XANADU,
            'newLinkType',
            [this.web3.utils.fromAscii(linkType), description])
            .execute();
    }

    async newLinks(linkType, fromData, data) {
        await new EthereumTransaction(
            XANADU,
            'newLink',
            [
                this.web3.utils.fromAscii(linkType),
                fromData,
                data
            ])
            .execute();
    }

    async getDataTypes() {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewDataType)
            .select('dataType')
            .select('description');

        return await query.executeQuery();
    }

    async getLinkTypes() {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewLinkType)
            .select('linkType')
            .select('description');

        return await query.executeQuery();
    }

    async getLinks(linkType, fromData, toData) {
        let query = new BackendQuery(new XanaduContract().contractAddress)
            .from(NewLink)
            .select('fromData')
            .select('toData')
            .where('linkType', linkType);

        if (fromData) {
           query.where('fromData', fromData);
        }

        if (toData) {
           query.where('toData', toData);
        }

        let ret = await query.executeQuery();
        let reduced = [];
        for (let i in ret) {
            let {fromData} = ret[i];
            if (reduced.some(s => s.fromData === fromData)) {
                continue;
            }
            reduced.push(ret[i]);
        }
        return reduced;
    }

}

export default Xanadu;
